module.exports = __webpack_public_path__ + "static/media/dynamic-ball-pit.5b895e20.gif";